import React, { Component } from 'react';
import './leafs.css'
class Leafs extends Component {
  state = {
    animated: false,
    blue: [{},{},{},{},{},{},{},{},{},],
    green: [{},{},{},{},{},{},{},{},{},{},{},{},{},]
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({animated: true})
    },100)
  }

  render() {
    const { blue, green, animated } = this.state
    return (
      <div className={`leafs ${animated ? 'animated' : ''}`} style={{zIndex: 0, position: 'absolute', width: '100%', height: '100%'}}>
        {blue.map((leaf, index) => (<div key={index} className={`leaf blue_leaf blue_leaf--${index}`}><img src="/images/leaf_blue.svg" alt="" /> </div>))}
        {green.map((leaf, index) => (<div key={index} className={`leaf green_leaf green_leaf--${index}`} ><img src="/images/leaf_green.svg" alt=""/> </div>))}
      </div>
    );
  }
}

export default Leafs;